import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9622c816"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "uploadMusic"
}, null, -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-upload"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createTextVNode("将文件拖到此处，或"), /*#__PURE__*/_createElementVNode("em", null, "点击上传")], -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, " 只能上传mp3|wav|wma|ogg|ape|acc|flac文件，且不超过50MB ", -1));

const _hoisted_5 = {
  class: "music_data_box"
};
const _hoisted_6 = {
  class: "music_data"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml-3 w-35 text-gray-600 inline-flex items-center"
}, "歌曲名", -1));

const _hoisted_8 = {
  class: "music_data"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml-3 w-35 text-gray-600 inline-flex items-center"
}, "歌手", -1));

const _hoisted_10 = /*#__PURE__*/_createTextVNode("上传");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_upload = _resolveComponent("el-upload");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_el_upload, {
    ref: "uploadMusicFile",
    name: "music",
    class: "upload-demo",
    drag: "",
    action: "https://manage1.hej6666.cn/upload_music",
    data: $setup.musicData,
    "auto-upload": false,
    "before-upload": $setup.beforeUpload,
    "on-success": $setup.music_on_success,
    limit: 1,
    "on-exceed": $setup.handleExceed
  }, {
    default: _withCtx(() => [_hoisted_2, _hoisted_3, _hoisted_4]),
    _: 1
  }, 8, ["data", "before-upload", "on-success", "on-exceed"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_input, {
    modelValue: $setup.music_data.music_name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.music_data.music_name = $event),
    placeholder: "歌曲名",
    clearable: ""
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_input, {
    modelValue: $setup.music_data.music_singer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.music_data.music_singer = $event),
    placeholder: "歌手",
    clearable: ""
  }, null, 8, ["modelValue"])])]), _createVNode(_component_el_button, {
    type: "primary",
    class: "up_music_btn",
    onClick: $setup.upload
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["onClick"])], 64);
}